import { DepartmentTemplate, FetchCrudData } from '../../models';
import { DepartmentTemplatesService } from '../../services';
import { ActionType } from './types';

export const getDepartmentTemplates = (filters: FetchCrudData) => ({
  type: ActionType.GET_DEPARTMENT_TEMPLATES,
  payload: DepartmentTemplatesService.getDepartmentTemplates(filters),
});
export const addDepartmentTemplate = (name: string) => ({
  type: ActionType.ADD_DEPARTMENT_TEMPLATE,
  payload: DepartmentTemplatesService.addDepartmentTemplate(name),
});
export const editDepartmentTemplate = (department: DepartmentTemplate) => ({
  type: ActionType.EDIT_DEPARTMENT_TEMPLATE,
  payload: DepartmentTemplatesService.editDepartmentTemplate(department),
});
export const deleteDepartmentTemplate = (id: string) => ({
  type: ActionType.DELETE_DEPARTMENT_TEMPLATE,
  payload: DepartmentTemplatesService.deleteDepartmentTemplate(id),
});
